import React from 'react';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import Tooltip from '@material-ui/core/Tooltip';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import styles from 'assets/jss/material-dashboard-pro-react/views/dashboard/dashboardStyle';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import { BodyM, Caption, CaptionBold } from 'components/Typography/Typography';
import { CircularProgressWithLabel } from 'views/Dashboard';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IBillTotalProps {
	percentValue?: string | number | null;
	text: string;
	value: string | number | null;
	tooltip?: string;
	color?: string;
	showLoading?: boolean;
	loadingProgress?: number;
}

const BillTotal = ({
	percentValue,
	text,
	value,
	tooltip,
	showLoading = false,
	loadingProgress = 0,
}: IBillTotalProps) => {
	const classes = useStyles();

	return (
		<GridItem xs={12} sm={6} lg={6} className={classes.billItem}>
			<Card>
				<CardBody>
					<ConditionalRender
						show={showLoading}
						onTrue={() => (
							<div>
								<CircularProgressWithLabel value={loadingProgress} />
							</div>
						)}
					/>
					<div
						className={classNames({
							[classes.success]: percentValue ? percentValue <= 0 : false,
							[classes.warning]: percentValue ? percentValue > 0 : false,
						})}
					>
						{percentValue && (
							<Tooltip title={String(tooltip)} classes={{ tooltip: classes.tooltip }}>
								<div>
									{percentValue > 0 ? (
										<ArrowUpward className={classes.billItemSmallIcon} />
									) : (
										<ArrowDownward className={classes.billItemSmallIcon} />
									)}
									<Caption>{`(${percentValue > 0 ? '+' : ''}${percentValue}%)`}</Caption>
								</div>
							</Tooltip>
						)}
					</div>
					<div>
						<BodyM color="primary-light">{text}</BodyM>
						<div>
							<BodyM color="primary-light">{String(value)}</BodyM>
							<CaptionBold>OMR</CaptionBold>
						</div>
					</div>
				</CardBody>
			</Card>
		</GridItem>
	);
};

export default BillTotal;
